export const isDevelopment = () => import.meta.env.DEV;

export const getApiHost = () => import.meta.env.VITE_API_HOST;
